import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiinternationalairporttaxi() {



const cardData = {
  keyword: "Pune to Mumbai International Airport Taxi",
  heading: "Lotus Cab: Pune to Mumbai International Airport Taxi",

  headingDescription:
    "Lotus Cab offers professional Pune to Mumbai International Airport Taxi services for timely and stress-free airport transfers. Whether you are traveling for business, international flights, family vacations, or corporate meetings, our reliable cab service ensures on-time drop at Chhatrapati Shivaji Maharaj International Airport. Our experienced drivers are well-trained for expressway and highway driving, ensuring safe and smooth travel. We provide transparent one-way and round-trip pricing with no hidden charges. AC sedans and spacious SUVs are available for individuals and groups. With 24/7 booking assistance and punctual pickup anywhere in Pune, we guarantee dependable airport transfer service.",

  top: "Top Places to Visit in Mumbai Near Airport with Lotus Cab",

  topPlaces: [
    {
      title: "Chhatrapati Shivaji Maharaj International Airport",
      description:
        "Mumbai International Airport is one of India’s busiest airports serving domestic and international travelers. Located in Andheri, it offers world-class facilities and seamless travel connectivity. Terminal 2 is known for its modern architecture and art installations. Business travelers frequently commute between Pune and Mumbai Airport. Timely airport transfer is essential to avoid flight delays. Lotus Cab ensures smooth and punctual airport drop service."
    },
    {
      title: "Juhu Beach",
      description:
        "Juhu Beach is one of Mumbai’s most popular coastal destinations near the airport. Visitors enjoy street food and scenic sunset views. It is a relaxing stop before or after a flight. Families and tourists frequently visit this area. It is well connected from airport terminals. A comfortable cab ensures smooth city travel."
    },
    {
      title: "Bandra Kurla Complex (BKC)",
      description:
        "BKC is a major business and corporate hub of Mumbai. Many international companies have offices here. Business travelers often require airport-to-BKC transfers. It is located close to the airport. Reliable taxi service ensures timely corporate meetings. Professional cab service makes business travel convenient."
    },
    {
      title: "Gateway of India",
      description:
        "Gateway of India is an iconic landmark in South Mumbai. It represents the city’s historic significance. Tourists visiting Mumbai often explore this monument. It is ideal for sightseeing after airport arrival. Comfortable outstation cab travel makes planning easy. It remains a must-visit destination."
    },
    {
      title: "Marine Drive",
      description:
        "Marine Drive is known as the Queen’s Necklace of Mumbai. It offers scenic coastal views and evening walks. Travelers often plan sightseeing around it. Located in South Mumbai, it is accessible via highway routes. Cab service ensures comfortable intercity travel. It is a popular tourist attraction."
    },
    {
      title: "Powai Lake",
      description:
        "Powai Lake is a peaceful attraction near the airport area. It offers beautiful lake views and nearby cafes. Ideal for short leisure breaks. It is located close to major IT hubs. Convenient airport cab service ensures smooth connectivity. Suitable for corporate travelers."
    },
    {
      title: "Andheri East & West",
      description:
        "Andheri is one of Mumbai’s busiest suburbs. It houses commercial centers and residential areas. Airport proximity makes it highly accessible. Many hotels are located here. Reliable taxi service ensures smooth travel. Popular for business and transit stays."
    },
    {
      title: "Bandra Bandstand",
      description:
        "Bandra Bandstand offers stunning Arabian Sea views. It is a popular romantic and family destination. Many Bollywood celebrities reside nearby. It is easily accessible via cab. Comfortable intercity taxi makes travel stress-free. A peaceful sightseeing stop in Mumbai."
    }
  ],

  services: [
    {
      name: "Pune to Mumbai Airport Cab",
      description:
        "Reliable cab service from Pune to Mumbai International Airport with timely pickup. Expressway travel ensures fast and smooth journey. Professional drivers handle highway driving safely. AC sedans and SUVs available. Transparent one-way pricing structure maintained. Ideal for domestic and international flights."
    },
    {
      name: "One Way Pune to Mumbai Airport Taxi",
      description:
        "One-way airport taxi allows you to pay only for single-side distance. No unnecessary return charges applied. Affordable pricing maintained. Suitable for early morning or late-night flights. Comfortable and punctual airport drop ensured. Hassle-free booking process available."
    },
    {
      name: "Round Trip Pune to Mumbai Airport Cab",
      description:
        "Round-trip cab option available for return scheduling. Ideal for airport pickup and drop. Flexible waiting and return timing supported. Transparent fare breakdown provided. Suitable for family and corporate travel. Smooth highway travel ensured."
    },
    {
      name: "Luxury Cab to Mumbai Airport from Pune",
      description:
        "Premium vehicles available for executive airport transfers. Plush seating enhances comfort during travel. Ideal for corporate clients and VIP guests. Professional chauffeurs ensure punctuality. Well-maintained luxury cars provided. Stress-free premium airport journey."
    },
    {
      name: "SUV Taxi Pune to Mumbai Airport",
      description:
        "Spacious SUV taxis suitable for group travel and extra luggage. Ideal for international travelers with baggage. Safe highway driving guaranteed. Comfortable interiors maintained. Transparent pricing policy followed. Smooth expressway connectivity ensured."
    },
    {
      name: "24/7 Airport Cab Pune to Mumbai",
      description:
        "Round-the-clock airport taxi service available. Early morning and midnight flights supported. Immediate booking confirmation provided. Reliable and punctual pickup ensured. Flexible departure scheduling available. Convenient airport transfer anytime."
    },
    {
      name: "Online Airport Taxi Booking Pune",
      description:
        "Easy online booking system available 24/7. Quick confirmation and driver details shared instantly. Transparent fare estimation provided. Multiple vehicle options available. Secure booking process ensured. Hassle-free airport planning supported."
    },
    {
      name: "Corporate Airport Transfer Pune to Mumbai",
      description:
        "Professional airport transfer for corporate clients. Executive sedans and SUVs available. Timely arrival ensured for business flights. Monthly billing options provided. Experienced drivers for smooth travel. Reliable corporate transport solution."
    }
  ],

  tableData: [
    ["Pune to Mumbai International Airport Taxi", "Pune to Mumbai Airport Cab"],
    ["Pune to Mumbai International Airport Drop", "One Way Pune to Mumbai Airport Taxi"],
    ["Round Trip Pune to Mumbai Airport Cab", "Affordable Pune to Mumbai Airport Taxi"],
    ["Luxury Cab to Mumbai Airport from Pune", "SUV Taxi Pune to Mumbai Airport"],
    ["24/7 Airport Cab Pune to Mumbai", "Online Airport Taxi Booking Pune"],
    ["Corporate Airport Transfer Pune to Mumbai", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "On-Time Airport Drop Guarantee",
      WhyChoosedescription:
        "We prioritize punctual airport arrivals. Expressway route planning reduces delay risk. Drivers monitor traffic conditions. Early departure scheduling supported. Timely drop ensured."
    },
    {
      WhyChooseheading: "Professional Highway Drivers",
      WhyChoosedescription:
        "Experienced drivers trained for long-distance travel. Safe expressway driving ensured. Smooth and secure journey maintained. Professional behavior guaranteed. Reliable airport transfer experience."
    },
    {
      WhyChooseheading: "Transparent Pricing Policy",
      WhyChoosedescription:
        "Clear per kilometer fare structure maintained. No hidden charges applied. Toll and parking explained before booking. Complete cost transparency provided. Trusted airport service."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV options available. Suitable for individuals and families. Luxury vehicles for executive travel. Clean and maintained fleet ensured. Flexible vehicle selection supported."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock customer assistance available. Immediate booking confirmation provided. Quick response to queries ensured. Reliable communication maintained. Stress-free coordination."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly Service",
      WhyChoosedescription:
        "Spacious vehicles ideal for family travel. Corporate airport transfer supported. Flexible departure timing available. Comfortable seating ensured. Safe and smooth travel guaranteed."
    },
    {
      WhyChooseheading: "Well-Maintained Vehicles",
      WhyChoosedescription:
        "Vehicles regularly serviced and cleaned. AC and safety checks performed. Comfortable interiors ensured. Reliable performance guaranteed. Smooth long-distance travel."
    },
    {
      WhyChooseheading: "Flexible One-Way & Round Trip Options",
      WhyChoosedescription:
        "One-way airport drop available. Round-trip scheduling supported. Flexible return timing offered. Transparent pricing policy maintained. Convenient booking solution."
    }
  ]
};

const faqData = [
  { question: "How long does it take from Pune to Mumbai Airport?", answer: "Travel time is approximately 3 to 4 hours via Mumbai-Pune Expressway depending on traffic conditions." },
  { question: "Do you provide one-way airport drop?", answer: "Yes, one-way airport taxi is available with transparent single-side pricing." },
  { question: "Is night airport taxi available?", answer: "Yes, 24/7 airport taxi service is available for late-night and early-morning flights." },
  { question: "Are SUVs available for airport transfer?", answer: "Yes, SUVs are available for family and group travel with extra luggage space." },
  { question: "Is fare fixed or per km?", answer: "Fare is calculated on per kilometer basis with transparent billing structure." },
  { question: "Can I book round trip airport taxi?", answer: "Yes, round-trip airport taxi option is available with flexible scheduling." },
  { question: "Is online booking available?", answer: "Yes, online airport cab booking is available 24/7 with instant confirmation." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, executive airport transfer service is available for corporate clients." },
  { question: "Are toll charges included?", answer: "Toll charges are shared transparently before booking confirmation." },
  { question: "Do you monitor flight timing?", answer: "Yes, we coordinate pickup timing according to flight schedule for smooth drop." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Sharma",
    feedback:
      "Booked Pune to Mumbai International Airport taxi for early morning flight. Driver arrived on time and travel was smooth via expressway. Transparent pricing impressed us. Comfortable vehicle ensured relaxed journey. Highly recommended for airport transfers.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "We used Lotus Cab for family airport drop. SUV was spacious for luggage. Driver was polite and punctual. No hidden charges in billing. Overall airport transfer experience was professional and reliable.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rajesh Mehta",
    feedback:
      "Corporate airport transfer from Pune to Mumbai was perfectly managed. Executive sedan provided. Timely drop ensured no flight delay. Transparent fare structure appreciated. Very dependable airport cab service.",
    rating: 5
  }
];




















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai International Airport Taxi",
  "image": "https://lotuscab.com/assets/images/pune-to-mumbai-airport-taxi.jpg", 
  "description": "Lotus Cab provides Pune to Mumbai International Airport taxi services with one way, round trip, luxury, and SUV options. Book affordable and reliable airport transfers, corporate pickups, and online cab booking with professional drivers for a comfortable journey.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-mumbai-international-airport-taxi"
  }
};



  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Pune to Mumbai International Airport Taxi | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai International Airport taxi with Lotus Cab. Affordable one way & round trip airport transfers with sedan, SUV & luxury cabs. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Chhatrapati Shivaji Maharaj International Airport Taxi, Pune to Mumbai Airport Cab, Pune to Mumbai International Airport Drop, One Way Pune to Mumbai Airport Taxi, Round Trip Pune to Mumbai Airport Cab, Affordable Pune to Mumbai Airport Taxi, Luxury Cab to Mumbai Airport from Pune, SUV Taxi Pune to Mumbai Airport, 24/7 Airport Cab Pune to Mumbai, Online Airport Taxi Booking Pune, Corporate Airport Transfer Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiinternationalairporttaxi;